const activityFeed = {
  title: "Activity Feed",
  columns: {
    property_name: "Property Name",
    event: "Event",
    timestamp: "Timestamp",
    contact_name: "Who",
    license_plate: "License Plate",
    type: "Type",
  },
};

export default activityFeed;
